import config from "../../config";

export const environmentalTopics = [
  {
    link: "https://www.epa.gov/environmental-topics",
    name: "Environmental Topics",
  },
  {
    link: "https://www.epa.gov/environmental-topics/air-topics",
    name: "Air",
  },
  {
    link: "https://www.epa.gov/bedbugs",
    name: "Bed Bugs",
  },
  {
    link: "https://www.epa.gov/environmental-topics/chemicals-and-toxics-topics",
    name: "Chemicals and Toxics",
  },
  {
    link: "https://www.epa.gov/environmental-topics/location-specific-environmental-information",
    name: "Environmental Information by Location",
  },
  {
    link: "https://www.epa.gov/environmental-topics/greener-living",
    name: "Greener Living",
  },
  {
    link: "https://www.epa.gov/environmental-topics/health-topics",
    name: "Health",
  },
  {
    link: "https://www.epa.gov/environmental-topics/land-waste-and-cleanup-topics",
    name: "Land, Waste, and Cleanup",
  },
  {
    link: "https://www.epa.gov/lead",
    name: "Lead",
  },
  {
    link: "https://www.epa.gov/mold",
    name: "Mold",
  },
  {
    link: "https://www.epa.gov/pesticides",
    name: "Pesticides",
  },
  {
    link: "https://www.epa.gov/radon",
    name: "Radon",
  },
  {
    link: "https://www.epa.gov/environmental-topics/science-topics",
    name: "Science",
  },
  {
    link: "https://www.epa.gov/environmental-topics/water-topics",
    name: "Water",
  },
  {
    link: "https://www.epa.gov/topics-epa-web",
    name: "A-Z Topic Index",
  },
];

export const lawsAndRegulationsTopics = [
  {
    link: "https://www.epa.gov/laws-regulations",
    name: "Laws and Regulations",
  },
  {
    link: "https://www.epa.gov/regulatory-information-sector",
    name: "By Business Sector",
  },
  {
    link: "https://www.epa.gov/regulatory-information-topic",
    name: "By Topics",
  },
  {
    link: "https://www.epa.gov/compliance",
    name: "Compliance",
  },
  {
    link: "https://www.epa.gov/enforcement",
    name: "Enforcement",
  },
  {
    link: "https://www.epa.gov/laws-regulations/laws-and-executive-orders",
    name: "Laws and Executive Orders",
  },
  {
    link: "https://www.epa.gov/guidance",
    name: "Guidance",
  },
  {
    link: "https://www.epa.gov/laws-regulations/regulations",
    name: "Regulations",
  },
];

export const aboutEPATopics = [
  {
    link: "https://www.epa.gov/aboutepa",
    name: "About EPA",
  },
  {
    link: "https://www.epa.gov/aboutepa/epa-organization-chart",
    name: "Organization Chart",
  },
  {
    link: "https://cfpub.epa.gov/locator/index.cfm",
    name: "Staff Directory",
  },
  {
    link: "https://www.epa.gov/planandbudget",
    name: "Planning, Budget, and Results",
  },
  {
    link: "https://www.epa.gov/careers",
    name: "Jobs and Internships",
  },
  {
    link: "https://www.epa.gov/aboutepa",
    name: "Headquarters Offices",
  },
  {
    link: "https://www.epa.gov/aboutepa/regional-and-geographic-offices",
    name: "Regional Offices",
  },
  {
    link: "https://www.epa.gov/aboutepa/research-centers-programs-and-science-advisory-organizations",
    name: "Labs and Research Centers",
  },
];

export const collapsableFooterTopics = [
  {
    link: "https://www.epa.gov/accessibility",
    name: "Accessibility",
  },
  {
    link: "https://www.epa.gov/privacy",
    name: "Privacy",
  },
  {
    link: "https://www.epa.gov/privacy/privacy-and-security-notice",
    name: "Privacy and Security Notice",
  },
];

export const home = [{ name: "Home", url: "/" }];

export const globalView = [
  { name: "Monitoring Plans", url: "/monitoring-plans" },
  { name: "QA Test Data", url: "qa/tests" },
  { name: "QA Cert Events, Extensions & Exemptions", url: "qa/qce-tee" },
  { name: "Emissions", url: "/emissions" },
  { name: "Export & Report", url: "/export" },
];

export const systemAdmin = [
  {
    name: "QA Maintenance",
    url: "/admin/qa-maintenance",
  },
  {
    name: "Error Suppression",
    url: "/admin/error-suppression",
  },
  {
    name: "Emission Submission Access",
    url: "/admin/em-submission-access",
  },
  {
    name: "Submission Report",
    url: "/admin/submissions-report",
  },
  {
    name: "Units Expected Submit Report",
    url: "/admin/units-expected-to-submit",
  },
];

export const systemAdminForSubHeader = [
  {
    name: "System Administration",
    url: "/admin",
    children: [
      {
        name: "QA Maintenance",
        url: "/admin/qa-maintenance",
      },
      {
        name: "Error Suppression",
        url: "/admin/error-suppression",
      },
      {
        name: "Emission Submission Access",
        url: "/admin/em-submission-access",
      },
      {
        name: "Submission Report",
        url: "/admin/submissions-report",
      },
      {
        name: "Units Expected Submit Report",
        url: "/admin/units-expected-to-submit",
      },
    ],
  },
];

export const getWorkspacePaths = () => {
  const workSpace = [
    {
      name: "Monitoring Plans",
      url: "/workspace/monitoring-plans",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "QA Test Data",
      url: "/workspace/qa/tests",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "QA Cert Events, Extensions & Exemptions",
      url: "/workspace/qa/qce-tee",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Emissions",
      url: "/workspace/emissions",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },

    {
      name: "Evaluate",
      url: "/workspace/evaluate",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Submit",
      url: "/workspace/submit",
      requiredRoles: [
        config.app.submitterRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
      ],
    },
    {
      name: "Export & Report",
      url: "/workspace/export",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "MATS Data Submission",
      url: "/workspace/mats-data-submission",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Configuration Management",
      url: "/workspace/configuration-management",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Bulk Import",
      url: "/workspace/bulk-import",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
  ];

  return workSpace;
};

export const getWorkspacePathsForSubHeader = () => {
  const workSpaceForSubHeader = [
    {
      name: "Monitoring Plans",
      url: "/workspace/monitoring-plans",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "QA & Certifications",
      url: "/workspace/qa",
      children: [
        {
          name: "Test Data",
          url: "/workspace/qa/tests",
        },
        {
          name: "Cert Events, Extensions & Exemptions",
          url: "/workspace/qa/qce-tee",
        },
      ],
    },
    {
      name: "Emissions",
      url: "/workspace/emissions",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Evaluate",
      url: "/workspace/evaluate",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Submit",
      url: "/workspace/submit",
      requiredRoles: [
        config.app.submitterRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
      ],
    },
    {
      name: "Export & Report",
      url: "/workspace/export",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "MATS Data Submission",
      url: "/workspace/mats-data-submission",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Configuration Management",
      url: "/workspace/configuration-management",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
    {
      name: "Bulk Import",
      url: "/workspace/bulk-import",
      requiredRoles: [
        config.app.preparerRole,
        config.app.sponsorRole,
        config.app.initialAuthorizerRole,
        config.app.submitterRole,
      ],
    },
  ];

  return workSpaceForSubHeader;
};
